// packages/components/src/hooks/useRegistrationAnalytics.ts
import { TAnalyticsEvent } from "@timeedit/registration-components";
import { AnalyticEventsClient } from "@timeedit/registration-schemas";
import { stripCustomerPart } from "@timeedit/registration-shared";
import { useCallback, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useAnalyticsEventMutation } from "../redux/api/analytics";
import { getEndpoints } from "../routes/RouteTypes";

interface TAnalyticsEvents {
  analyticsEvent: TAnalyticsEvent;
}

export function useAnalytics(): TAnalyticsEvents {
  const [analyticsEventMutation] = useAnalyticsEventMutation();

  const analyticsEvent: TAnalyticsEvent = useCallback(
    (event, properties) => {
      analyticsEventMutation({
        event,
        properties: {
          ...properties,
          page: stripCustomerPart(window.location.pathname),
        },
      });
    },
    [analyticsEventMutation]
  );

  return {
    analyticsEvent,
  };
}

const SCHEDULE_PATH = getEndpoints().schedule.path;

export function useSchedulePageGrouping(): void {
  const location = useLocation();
  const { analyticsEvent } = useAnalytics();

  useEffect(() => {
    // Only group schedule view for now
    if (location.pathname.includes(SCHEDULE_PATH)) {
      analyticsEvent(AnalyticEventsClient.pageView, {
        context: "useSchedulePageGrouping",
        referrer: document.referrer || "",
        title: "",
      });
    }
  }, [analyticsEvent, location.pathname]);
}
